import { Button } from "../ui/Button";
import logoasniere from "../assets/img/img/logobrive.png";
import logobrive from "../assets/img/img/logobrive.png";
import logotoulouse from "../assets/img/img/logotoulouse.png";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import secteursList from "../utils/secteurs";
import { Input } from "../ui/Input";
import { Textarea } from "../ui/TextArea";
import axios from "../axios/AxiosInstance";
import { Label } from "../ui/Label";
import { Checkbox } from "../ui/Checkbox";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/Select";
import { Tabs, TabsList } from "../ui/Tabs";
import { toast, Toaster } from "sonner";
import MultiSelect from "../ui/MultiSelect";

export default function Contact() {
  console.log("Page Contact rendue");

      
  const [candSelectedOptions] = useState([]);
  const [recruteurSelectedOptions, setRecruteurSelectedOptions] = useState([]);
    const [loading, setLoading] = useState(false);

  const agences = [
    {
      id: "asnières",
      name: " J'M intérim - Asnières sur Seine",
      logo: logoasniere,
      email: "recrutement@jm-interim.com",
      email2: "contact@jm-interim.com",
      phone: "01 80 88 21 35",
      address: "4 avenue Laurent Cély, hall A, 92600 Asnières sur Seine",
    },

    {
      id: "brive",
      name: " J'M capeneo - Brive la gaillarde",
      logo: logobrive,
      email: "brive@jm-interim.com",
      phone: "05 55 17 49 79",
      address: " 26 Bis Av. Ribot,19100 Brive-la-Gaillarde",
    },
    {
      id: "toulouse",
      name: " J'M capeneo santé - Toulouse",
      logo: logotoulouse,
      email: "sante@jm-interim.com",
      phone: "05 61 11 11 00",
      address:
        " Carré Wilson, 64 Rue Benjamin Baillaud Bâtiment C, 31500 Toulouse",
    },
  ];

  const [selectedId] = useState(agences[0].id);
  agences.find((a) => a.id === selectedId);
  candSelectedOptions.map((opt) => opt.value); // récupération depuis react-select

  
  
  function handleRecruteurSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const data = new FormData(form);

    const recruiterFirstname = data.get("recruiterFirstname");
    const recruiterLastname = data.get("recruiterLastname");
    const recruiterEmail = data.get("recruiterEmail");
    const recruiterPhone = data.get("recruiterPhone");
    const secteurs = recruteurSelectedOptions.map((opt) => opt.value);
    const recruiterSiret = data.get("recruiterSiret");
    const recruiterZone = data.get("recruiterZone");
    const recruiterCa = data.get("recruiterCa");
    const recruiterNombreRecrutement = data.get("recruiterNombreRecrutement");

    const recruiterTransport = data.get("recruiterTransport");
    const recruiterProject = data.get("recruiterProject");

    const file = data.get("file");
    const privacyChecked = data.get("recruiterPrivacy") !== null;

    if (!privacyChecked) {
      toast.error("Veuillez accepter la politique de confidentialité.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("recruiterFirstname", recruiterFirstname);
    formData.append("recruiterLastname", recruiterLastname);
    formData.append("recruiterPhone", recruiterPhone);
    formData.append("recruiterEmail", recruiterEmail);
    formData.append("recruiterSiret", recruiterSiret);
    formData.append("recruiterCa", recruiterCa);

    formData.append("recruiterZone", recruiterZone);
    formData.append("recruiterNombreRecrutement", recruiterNombreRecrutement);
    formData.append("recruiterSecteurs", secteurs);

    formData.append("recruiterTransport", recruiterTransport);
    formData.append("recruiterProject", recruiterProject);

    setLoading(true);

    axios
      .post("recruteur/website", formData)
      .then((res) => {
        toast.success("Votre demande a bien été envoyée !");
        form.reset(); // reset des inputs
        console.log(res.data);
        setRecruteurSelectedOptions([]); // reset du react-select multiselect
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status === 400) {
          toast.error("Votre profil existe déjà.");
        } else {
          toast.error("Une erreur est survenue. Merci de réessayer.");
        }
      })
      .finally(() => {
        setLoading(false); // stoppe le loader
      });
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Toaster position="top-right" richColors />

      <main className="flex-grow">
        <section className="bg-gradient-to-r from-blue-50 to-indigo-50 pt-[154px] pb-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center mb-10">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Devenez recruteur
              </h1>
              <p className="text-lg text-gray-700"></p>
            </div>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200">
                <Tabs>
                  <TabsList className="w-full mb-6 bg-blue-100">
                    <p className="text-white px-4 py-2 rounded bg-blue-500">
                      Je suis Recruteur(se)
                    </p>
                  </TabsList>

                  <div value="freelance">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">
                      Contact Recruteur
                    </h2>
                    <form
                      onSubmit={handleRecruteurSubmit}
                      className="space-y-6"
                    >
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                          <Label htmlFor="recruiterLastname">Nom *</Label>
                          <Input
                            id="recruiterLastname"
                            name="recruiterLastname"
                            placeholder="Votre nom"
                            required
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="recruiterFirstname">Prénom *</Label>
                          <Input
                            id="recruiterFirstname"
                            name="recruiterFirstname"
                            placeholder="Votre prénom"
                            required
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                          <Label htmlFor="recruiterEmail">Email *</Label>
                          <Input
                            id="recruiterEmail"
                            name="recruiterEmail"
                            type="email"
                            placeholder="votre.email@exemple.com"
                            required
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="recruiterPhone">Téléphone *</Label>
                          <Input
                            id="recruiterPhone"
                            name="recruiterPhone"
                            type="tel"
                            placeholder="06 12 34 56 78"
                            required
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="recruiterSiret">
                            SIRET (si existant)
                          </Label>
                          <Input
                            id="recruiterSiret"
                            name="recruiterSiret"
                            placeholder="Numéro de SIRET"
                            className="w-full"
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="recruiterZone">
                            Zone géographique envisagée
                          </Label>
                          <Input
                            id="recruiterZone"
                            name="recruiterZone"
                            placeholder="Zone"
                            className="w-full"
                            required
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="recruiterCa">
                            CA mensuel envisagé
                          </Label>
                          <Input
                            id="recruiterCa"
                            name="recruiterCa"
                            placeholder="CA"
                            className="w-full"
                            required
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="recruiterNombreRecrutement">
                            Nombre de recrutement mensuel envisagé
                          </Label>
                          <Input
                            id="recruiterNombreRecrutement"
                            name="recruiterNombreRecrutement"
                            placeholder="Nombre de recrutements"
                            className="w-full"
                            required
                          />
                        </div>
                        <div className="space-y-2">
                          <MultiSelect
                            items={secteursList}
                            selectedOptions={recruteurSelectedOptions}
                            setSelectedOptions={setRecruteurSelectedOptions}
                            name="recruiterSecteurs"
                            label="Secteurs recherchés"
                            placeholder="Sélectionnez le(s) secteur(s)"
                          />
                        </div>

                        <div className="space-y-2">
                          <Label htmlFor="recruiterTransport">
                            Moyen de transport
                          </Label>
                          <Select
                            required
                            id="recruiterTransport"
                            name="recruiterTransport"
                            className="w-full text-stone-400"
                          >
                            <SelectTrigger
                              id="recruiterTransport"
                              className="text-gray-400"
                            >
                              <SelectValue placeholder="Sélectionnez votre moyen de transport" />
                            </SelectTrigger>
                            <SelectContent className="bg-white text-black-100">
                              <SelectItem value="transport">
                                Transport en commun
                              </SelectItem>
                              <SelectItem value="moto">Moto</SelectItem>
                              <SelectItem value="voiture">Voiture</SelectItem>
                              <SelectItem value="trotinette">
                                Trotinette
                              </SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="recruiterProject">
                          Description de votre projet *
                        </Label>
                        <Textarea
                          id="recruiterProject"
                          name="recruiterProject"
                          placeholder="Décrivez votre projet"
                          rows={5}
                          required
                          className="w-full"
                        />
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="recruiterFile">
                          Votre CV (.pdf, .doc, .docx) *
                        </Label>
                        <Input
                          id="recruiterFile"
                          name="file"
                          type="file"
                          accept=".pdf,.doc,.docx"
                          className="text-gray-400"
                        />
                      </div>

                      <div className="flex items-center space-x-2">
                        <Checkbox
                          id="recruiterPrivacy"
                          name="recruiterPrivacy"
                          required
                        />
                        <Label
                          htmlFor="recruiterPrivacy"
                          className="text-sm text-gray-600 font-normal"
                        >
                          J'accepte que mes données soient traitées conformément
                          à la{" "}
                          <a
                            href="/politique-confidentialite"
                            className="text-blue-600 hover:underline"
                          >
                            politique de confidentialité
                          </a>{" "}
                          *
                        </Label>
                      </div>

                      <Button
                        type="submit"
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                        disabled={loading}
                      >
                        {loading ? (
                          <div className="flex items-center space-x-2">
                            <span className="loader border-white border-t-transparent border-2 rounded-full w-4 h-4 animate-spin"></span>
                            <span>Envoi...</span>
                          </div>
                        ) : (
                          "Envoyer ma demande"
                        )}
                      </Button>
                      <p className="text-sm text-gray-500 pt-2">
                        Les champs marqués d'un * sont obligatoires
                      </p>
                    </form>
                  </div>
                </Tabs>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Nos coordonnées
                </h2>

                <div className="space-y-8">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-100 rounded-full p-3 mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        Adresse du siège social
                      </h3>
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=J'M+Intérim+4+avenue+Laurent+Cely+hall+A+92600+Asnières-sur-Seine"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-400 hover:underline"
                      >
                        <p className="text-gray-700">
                          4 avenue Laurent Cely, hall A, 92600
                          Asnières-sur-Seine
                        </p>{" "}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-100 rounded-full p-3 mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                      </svg>
                    </div>
                    <div>
                      <a href="tel:0180882135">
                        <h3 className="text-lg font-semibold text-gray-900 mb-1">
                          Téléphone
                        </h3>
                        <p className="text-gray-700 mb-1">
                          01.80.88.21.35
                        </p>{" "}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-100 rounded-full p-3 mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        Email
                      </h3>

                      <a
                        href="mailto:contact@jm-interim.com"
                        className="text-gray-400"
                      >
                        <p className="text-gray-700 mb-1">
                          Informations générales : contact@jm-interim.com
                        </p>{" "}
                      </a>
                      <a href="mailto:recrutement@jm-interim.com">
                        <p className="text-gray-700 mb-1">
                          Candidatures : recrutement@jm-interim.com
                        </p>
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-100 rounded-full p-3 mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        Horaires d'ouverture
                      </h3>
                      <p className="text-gray-700 mb-1">
                        Lundi - Vendredi : 8h00 - 18h00
                      </p>
                      <p className="text-gray-700">Samedi - Dimanche : Fermé</p>
                      <br></br>
                      <Link to="/a-propos">
                        <p className="text-blue-500 underline">
                          Voir nos autres agences
                        </p>
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="mt-10">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">
                    Suivez-nous
                  </h3>
                  <div className="flex space-x-4">
                    <a
                      href="https://www.facebook.com/jm.interim"
                      className="bg-blue-100 hover:bg-blue-200 text-blue-600 p-3 rounded-full transition-colors"
                    >
                      <svg
                        className="h-6 w-6"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>

                    <a
                      href="https://www.instagram.com/jm_interim/#"
                      className="bg-blue-100 hover:bg-blue-200 text-blue-600 p-3 rounded-full transition-colors"
                    >
                      <svg
                        className="h-6 w-6"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
